import { render, staticRenderFns } from "./AsCallList.vue?vue&type=template&id=0656bbb7&scoped=true"
import script from "./AsCallList.vue?vue&type=script&lang=js"
export * from "./AsCallList.vue?vue&type=script&lang=js"
import style0 from "./AsCallList.vue?vue&type=style&index=0&id=0656bbb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0656bbb7",
  null
  
)

export default component.exports